import React from "react";
import {
  FaLinkedinIn,
  FaYoutube,
  FaGithub
} from "react-icons/fa";
import styles from "./Footer.module.css";
import { socialMedia } from "../../data";

const date = new Date();
const currentYear = date.getFullYear();

const { linkedin, youtube, github } = socialMedia;

const Footer = () => {
  return (
    <div style={{ backgroundColor: "#e9f4fd" }}>
      <div className={styles.footer}>
        <div className={styles["footer__icons"]}>
          <a href={linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
          <a href={youtube} target="_blank" rel="noreferrer" aria-label="YouTube">
            <FaYoutube />
          </a>
          <a href={github} target="_blank" rel="noreferrer" aria-label="GitHub">
            <FaGithub />
          </a>
        </div>
        <span className={styles["footer__separator"]}>|</span>
        <div className={styles["footer__legaldetails"]}>
          <a className={styles["foot__legalText"]} href="https://sites.google.com/encycdata.com/encycdata-website-terms-of-use/home" target="_blank" rel="noreferrer">
            Terms of Use
          </a>
          <span className={styles["footer__separator"]}>|</span>
          <a className={styles["foot__legalText"]} href="https://sites.google.com/encycdata.com/encycdata-privacy-policy/home" target="_blank" rel="noreferrer">
            Privacy Policy
          </a>
          <span className={styles["footer__separator"]}>|</span>
          <a className={styles["foot__legalText"]} href="https://sites.google.com/encycdata.com/encycdata-privacy-policy/home" target="_blank" rel="noreferrer">
            Do Not Sell My Information
          </a>
        </div>
        <span className={styles["footer__separator"]}>|</span>
        <p className={styles["footer__copyright-text"]}>
          Copyright © {currentYear} Encycdata and/or its Affiliates, All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
